
const UIString = {

    'ko':{
        'INVALID_CORP_CODE_FORMAT':'기업 코드 형식에 오류가 있습니다.',
        'CORP_CODE_IS_REQUIRED':'기업 코드를 입력하시기 바랍니다.',
        'INVALID_EMAIL_FORMAT':'이메일 형식에 오류가 있습니다.',
        'EMAIL_IS_REQUIRED':'이메일을 입력하시기 바랍니다.',
        'PASSWORD_IS_REQUIRED':'패스워드를 입력하시기 바랍니다.',
        'INVALID_PASSWORD_FORMAT':'패스워드는 6자 이상, 40자 이하로 입력하시기 바랍니다.',
        'CORP_ADMIN_USER_LOGIN':'기업 회원 관리자 로그인',
        'CORP_CODE':'기업 코드',
        'EMAIL':'이메일',
        'PASSWORD':'패스워드',
        'LOGIN':'로그인',
        'FORGOT_PASSWORD':'패스워드를 잊으셨나요?',
        'FORGOT_CORP_CODE':'기업 코드를 잊으셨나요?',
        'CONFIRM':'확인',
        'PAGE_NOT_FOUND':'요청하신 페이지가 없습니다.',

        'DASHBOARD':'대시보드',
    },

};

export default UIString;